
<div id="kt_app_content" class="app-content flex-column-fluid">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Layout-->
        <div class="d-flex flex-column flex-lg-row">
            <!--begin::Content-->
            <div class="flex-lg-row-fluid me-lg-15 order-2 order-lg-1 mb-10 mb-lg-0">
                <!--begin::Card-->
                <div class="=card-flush pt-3 mb-5 mb-xl-10">

                  
                    <!--end::Card header-->
                    <!--begin::Card body-->
                    <div class="card-body pt-3">
                        <!--begin::Section-->
                      
                        <!--end::Section-->
                        <!--begin::Section-->
                        <div class="mb-0 text-center">
                            <!--begin::Title-->
                            <!--end::Title-->
                            <!--begin::Product table-->
                            <div class="title mb-10">
                               <img src="/assets/media/errors/success.gif" alt="">
                                <h4>Succès! </h4> 
                                <span>Votre offer a été changé avec succès!</span><br>
                               
                               </div>
                               <div class="retour cursor-pointer">
                                <a (click)="goToNotreCompte()">Consulter votre abonnement</a>
                               </div>
                            <!--end::Product table-->
                        </div>
                        <!--end::Section-->
                    </div>
                    <!--end::Card body-->
                </div>
                <!--end::Card-->
                <!--begin::Card-->
               
                <!--end::Card-->
            </div>


            <!--end::Content-->
            <!--begin::Sidebar-->
           
            <!--end::Sidebar-->
        </div>
        <!--end::Layout-->
    </div>
    <!--end::Content container-->
</div>
